import { render, staticRenderFns } from "./gptGet.vue?vue&type=template&id=4420f8a5&scoped=true"
import script from "./gptGet.vue?vue&type=script&lang=js"
export * from "./gptGet.vue?vue&type=script&lang=js"
import style0 from "./gptGet.vue?vue&type=style&index=0&id=4420f8a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4420f8a5",
  null
  
)

export default component.exports